<template>
  <div class="row">
    <div class="col-md-8 offset-md-2 bg-light">
      <div v-if="enableFacebookLogin || enableGoogleLogin" class="row pt-4">
        <div class="col-md-8 offset-md-2 px-3">
          <facebook-sign-in v-if="enableFacebookLogin" :login-url="facebookLoginUrl" class="mb-3" />
          <google-sign-in v-if="enableGoogleLogin" :login-url="googleLoginUrl" class="mb-3" />
        </div>
      </div>

      <sign-in-form :enable-forgot-password="enableForgotPassword"
                    :forgot-password-url="forgotPasswordUrl" :organisation-id="organisationId" :sign-in-path="signInPath"
                    :submit-button-text="signInButtonText" class="px-3 px-md-4"
                    @authenticity-token-updated="authenticityTokenUpdated"
                    @authenticated="authenticated" @mfa-setup-required="mfaSetupRequired" @mfa-token-required="mfaTokenRequired"
                    @missing-info-required="missingInfoRequired" />

      <verify-mfa-token-modal v-if="showMfaTokenModal" v-bind="mfaTokenModalProps"
                              @authenticity-token-updated="authenticityTokenUpdated"
                              @authenticated="authenticated" @missing-info-required="missingInfoRequired" />
      <missing-info-modal v-if="showMissingInfoModal" v-bind="missingInfoModalProps" @completed="missingInfoCompleted" />
    </div>
  </div>
</template>

<script>
import FacebookSignIn from './facebook-sign-in'
import GoogleSignIn from './google-sign-in'
import { inject } from 'vue'
import MissingInfoModal from './missing-info-modal'
import SignInForm from './sign-in-form'
import VerifyMfaTokenModal from './verify-mfa-token-modal'

const DEFAULT_FORGOT_PASSWORD_URL = '/users/password/new'
const DEFAULT_SIGN_IN_PATH = '/users/sign_in'

export default {
  components: { FacebookSignIn, GoogleSignIn, MissingInfoModal, SignInForm, VerifyMfaTokenModal },

  props: {
    enableFacebookLogin: {
      type: Boolean,
      required: false,
      default: false
    },

    enableForgotPassword: {
      type: Boolean,
      required: false,
      default: true
    },

    enableGoogleLogin: {
      type: Boolean,
      required: false,
      default: false
    },

    facebookLoginUrl: {
      type: String,
      required: false
    },

    forgotPasswordUrl: {
      type: String,
      required: false,
      default: DEFAULT_FORGOT_PASSWORD_URL
    },

    googleLoginUrl: {
      type: String,
      required: false
    },

    organisationId: {
      type: Number,
      required: true
    },

    signInButtonText: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('member.account.authentication_modal.sign_in_submit') }
    },

    signInPath: {
      type: String,
      required: false,
      default: DEFAULT_SIGN_IN_PATH
    }
  },

  data() {
    return {
      mfaTokenModalProps: {
        statusCheckPath: null,
        supportsRecoveryCodes: false,
        supportsSms: false,
        tokenHelpText: null,
        userId: null,
        useRecoveryCodePath: null,
        verifyTokenPath: null
      },
      missingInfoModalProps: {
        requiredFields: [],
        additionalFieldConfigs: [],
        euDataProcessingConsentData: {},
        phoneNumberLabel: '',
        postcodeLabel: ''
      },
      showMfaTokenModal: false,
      showMissingInfoModal: false
    }
  },

  methods: {
    authenticated({ afterSignInRedirect }) {
      window.location.href = afterSignInRedirect
    },

    authenticityTokenUpdated(newAuthenticityToken) {
      const tokenElement = document.querySelector('meta[name="csrf-token"]')
      tokenElement.setAttribute('content', newAuthenticityToken)
    },

    mfaSetupRequired({ enableMfaPath }) {
      window.location.href = enableMfaPath
    },

    mfaTokenRequired(mfaParameters) {
      this.showMfaTokenModal = true
      this.mfaTokenModalProps = mfaParameters
    },

    missingInfoCompleted({ redirectUrl }) {
      this.authenticated({ afterSignInRedirect: redirectUrl })
    },

    missingInfoRequired({
      requiredFields, additionalFieldConfigs, euDataProcessingConsentData, phoneNumberLabel, postcodeLabel
    }) {
      this.showMissingInfoModal = true
      this.missingInfoModalProps = { requiredFields, additionalFieldConfigs, euDataProcessingConsentData,
                                     phoneNumberLabel, postcodeLabel }
    }
  }
}
</script>
